import { useMutation, useQueryClient } from 'react-query'

import { addToast } from 'components/Toast/Toast'
import { subscribeToUser } from 'services/endpoints/profile'
import type { SubscribePayload } from 'types/api/profile'

export function useSubscribeMutation({
  otherUserId,
  selectedSubscriptionPlan,
  t,
  onClose,
  onSubscribed,
}: {
  otherUserId?: string
  selectedSubscriptionPlan: string | null
  t: (key: string) => string
  onClose: () => void
  invalidateKey: readonly any[]
  onSubscribed?: () => void
}) {
  const queryClient = useQueryClient()

  const subscribeToModel = async (paymentMethod: {
    method: 'card' | 'deposit'
    cardId: string | undefined
    rebill?: boolean
    taxRate?: any
    taxRateFee?: any
    tax?: any
    tax_rate?: any
  }) => {
    if (!otherUserId) {
      throw new Error('Missing otherUserId for subscribe')
    }

    if (!selectedSubscriptionPlan) {
      throw new Error('Missing subscription plan for subscribe')
    }

    const subscribePayload: SubscribePayload = {
      id: otherUserId,
      subscription_plan_id: selectedSubscriptionPlan,
      promo_campaign_id: undefined,
      payment_method: paymentMethod.method,
      card_id: paymentMethod.cardId,
      rebill: paymentMethod?.rebill,
      tax: paymentMethod?.tax ?? paymentMethod?.taxRate,
      tax_rate:
        paymentMethod?.tax_rate ??
        paymentMethod?.taxRateFee,
    }

    return await subscribeToUser(subscribePayload)
  }

  const subscribeMutation = useMutation(
    async (paymentMethod: {
      method: 'card' | 'deposit'
      cardId: string | undefined
      rebill?: boolean
      taxRate?: any
      taxRateFee?: any
      tax?: any
      tax_rate?: any
    }) => await subscribeToModel(paymentMethod),
    {
      onSuccess: resp => {
        onClose()

        if (resp?.data?.is_subscribed) {
          onSubscribed?.()
        }

        queryClient.invalidateQueries(
          ['conversations'],
          {
            refetchActive: true,
            refetchInactive: true,
          }
        )
      },

      onError: () => {
        onClose()
        addToast(
          'error',
          t('error:anErrorOccuredPleaseTryAgain')
        )
      },
    }
  )

  return { subscribeMutation }
}